import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import type { IEmailFormTemplate } from ".";
import { type TEmailForm, emailFormSchema } from "./resolver";

export const getEmailFormDefaultValues = (emailInfos: Partial<TEmailForm>, templates: IEmailFormTemplate[]) => ({
  templateType: templates.length ? templates[0].name : undefined,
  subject: templates.length ? templates[0].subject : "",
  content: templates.length ? templates[0].content : "",
  attachments: emailInfos?.attachments ?? [],
  ...emailInfos,
});

export const useEmailForm = (
  emailInfos: Partial<TEmailForm>,
  templates: IEmailFormTemplate[],
  emailsLimit?: number
) => {
  const form = useForm<TEmailForm>({
    resolver: yupResolver(emailFormSchema(emailsLimit)),
    defaultValues: getEmailFormDefaultValues(emailInfos, templates),
  });
  return form;
};
